import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";

export default function PhasePlaceholder({ phase, title, description }: { phase: number; title: string; description: string }) {
  return (
    <Card className="max-w-2xl mx-auto mt-8">
      <CardContent className="p-8 space-y-4">
        <div className="flex items-center gap-2 text-muted-foreground">
          <Clock className="h-4 w-4" />
          <span className="text-xs uppercase tracking-wide">Coming in Phase {phase}</span>
        </div>
        <h2 className="text-2xl font-semibold">{title}</h2>
        <p className="text-muted-foreground">{description}</p>
        <Button asChild variant="outline"><Link to="/partner/research">← Back to Research Hub</Link></Button>
      </CardContent>
    </Card>
  );
}
